import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [],
  template: `
    <div class="pagination-container">
      <div class="page-size-selector">
        <label for="pageSize">Rows per page:</label>
        <select
          id="pageSize"
          [value]="pageSize"
          (change)="onPageSizeChange(+$any($event.target).value)">
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </div>

      <div class="pagination-info">
        <ng-content></ng-content>
      </div>

      <div class="pagination-controls">
        <button
          class="pagination-btn"
          [disabled]="!hasPreviousPage"
          (click)="onPageChange(1)"
          aria-label="First page">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2">
            <polyline points="11 17 6 12 11 7"></polyline>
            <polyline points="18 17 13 12 18 7"></polyline>
          </svg>
        </button>
        <button
          class="pagination-btn"
          [disabled]="!hasPreviousPage"
          (click)="onPageChange(pageNumber - 1)"
          aria-label="Previous page">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </button>
        <button
          class="pagination-btn"
          [disabled]="!hasNextPage"
          (click)="onPageChange(pageNumber + 1)"
          aria-label="Next page">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>
        <button
          class="pagination-btn"
          [disabled]="!hasNextPage"
          (click)="onPageChange(totalPages)"
          aria-label="Last page">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2">
            <polyline points="13 17 18 12 13 7"></polyline>
            <polyline points="6 17 11 12 6 7"></polyline>
          </svg>
        </button>
      </div>
    </div>
  `,
  styles: [
    `
      .pagination-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 20px;
        border-top: 1px solid #e5e7eb;
        background: #f9fafb;
        flex-shrink: 0;
      }

      .page-size-selector {
        display: flex;
        align-items: center;
        gap: 8px;

        label {
          font-size: 14px;
          color: #6b7280;
          font-family: var(
            --ukg_sys_fontFamily_primaryTight,
            -apple-system,
            BlinkMacSystemFont,
            'Segoe UI',
            sans-serif
          );
        }

        select {
          padding: 6px 12px;
          border: 1px solid #d1d5db;
          border-radius: 4px;
          font-size: 14px;
          background: white;
          cursor: pointer;
          font-family: var(
            --ukg_sys_fontFamily_primaryTight,
            -apple-system,
            BlinkMacSystemFont,
            'Segoe UI',
            sans-serif
          );
        }
      }

      .pagination-info {
        font-size: 14px;
        color: #6b7280;
        font-family: var(
          --ukg_sys_fontFamily_primaryTight,
          -apple-system,
          BlinkMacSystemFont,
          'Segoe UI',
          sans-serif
        );
      }

      .pagination-controls {
        display: flex;
        gap: 4px;
      }

      .pagination-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        border: 1px solid #d1d5db;
        border-radius: 4px;
        background: white;
        color: #6b7280;
        cursor: pointer;
        font-family: var(
          --ukg_sys_fontFamily_primaryTight,
          -apple-system,
          BlinkMacSystemFont,
          'Segoe UI',
          sans-serif
        );

        &:hover:not(:disabled) {
          background: #f3f4f6;
        }

        &:disabled {
          opacity: 0.4;
          cursor: not-allowed;
        }
      }
    `,
  ],
})
export class PaginationComponent {
  @Input() pageNumber = 1;
  @Input() pageSize = 10;
  @Input() totalPages = 1;
  @Input() hasPreviousPage = false;
  @Input() hasNextPage = false;

  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();

  onPageChange(page: number): void {
    this.pageChange.emit(page);
  }

  onPageSizeChange(size: number): void {
    this.pageSizeChange.emit(size);
  }
}
